import type { AlertCategory, AlertRule } from '@/services/adminAlertsService';

export const CATEGORY_ORDER: AlertCategory[] = ['reviews', 'money', 'bookings', 'accounts', 'system'];

export const CATEGORY_LABELS: Record<AlertCategory, string> = {
  reviews: 'Reviews & approvals',
  money: 'Money & safety',
  bookings: 'Bookings',
  accounts: 'Accounts',
  system: 'System',
};

export const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super admins',
  admin: 'Admins',
  manager: 'Managers',
  staff: 'Staff',
  support: 'Support',
};

export const ROLE_SINGULAR: Record<string, string> = {
  super_admin: 'Super admin',
  admin: 'Admin',
  manager: 'Manager',
  staff: 'Staff',
  support: 'Support',
};

export const roleLabel = (role: string) => ROLE_LABELS[role] || role;

export const summariseRecipients = (rule: AlertRule): string => {
  const roles = rule.recipientRoles.map(roleLabel);
  const others = rule.recipientAdminIds.length + rule.extraEmails.length + rule.extraPhones.length;

  if (!roles.length) {
    if (!others) return 'No recipients';
    return `${others} ${others === 1 ? 'person' : 'people'}`;
  }
  if (!others) return roles.join(', ');
  return `${roles.join(', ')} + ${others} ${others === 1 ? 'other' : 'others'}`;
};
